import { useU2000SearchHandlers } from '../../u2000Core/hooks/handler/U2000UseSearchHandlers';
import useU2000AxiosAuthenticated from '../../u2000Core/axios/U2000UseAxiosAuthenticated';
import type { U2000SearchPayload, U2000SearchResult } from '../../u2000Core/components/tables/basic/U2000BasicTable';
import { U2000GridStateEnumPaginationDirection } from '../../u2000Core/reducer/formReducer/U2000GridState';
import { doSearchDocuments, type U3500DocumentSearchItem } from '../U3500Service';

export interface UseU3500DocumentSearchHandlersParams {
  onSuccess?: (
    searchResult: U2000SearchResult<U3500DocumentSearchItem>,
    direction: U2000GridStateEnumPaginationDirection
  ) => void;
  onError?: (errors: { error: unknown }) => void;
}

/**
 * Handler dédié : délègue à useU2000SearchHandlers + doSearchDocuments.
 */
export function useU3500DocumentSearchHandlers({
  onSuccess,
  onError,
}: UseU3500DocumentSearchHandlersParams) {
  const u2000AxiosAuthenticated = useU2000AxiosAuthenticated();

  return useU2000SearchHandlers<U3500DocumentSearchItem>({
    doSearchFn: async (searchPayload: U2000SearchPayload) => {
      return await doSearchDocuments(u2000AxiosAuthenticated, searchPayload);
    },
    onSuccess,
    onError,
  });
}
